<template>
  <div class="wizard wizard-4" id="kt_wizard_v4" data-wizard-state="step-first">
    <div class="wizard-nav">
      <div class="wizard-steps">
        <!-- Step 1 -->
        <div
          class="wizard-step"
          data-wizard-type="step"
          data-wizard-state="current"
          @click="handleStepClick(1)"
        >
          <div class="wizard-wrapper">
            <div class="wizard-number">1</div>
            <div class="wizard-label">
              <div class="wizard-title">Thông tin sản phẩm</div>
              <div class="wizard-desc">Thiết lập thông tin cơ bản</div>
            </div>
          </div>
        </div>

        <!-- Step 2 (Pricing) -->
        <div
          v-if="showPricingStep"
          class="wizard-step"
          data-wizard-type="step"
          @click="handleStepClick(2)"
        >
          <div class="wizard-wrapper">
            <div class="wizard-number">2</div>
            <div class="wizard-label">
              <div class="wizard-title">Giá Sản phẩm</div>
              <div class="wizard-desc">Cấu hình giá theo kho</div>
            </div>
          </div>
        </div>

        <!-- Step 3/nil (Combo) -->
        <div
          v-if="showCombo"
          class="wizard-step"
          data-wizard-type="step"
          @click="handleStepClick(getComboStepNumber)"
        >
          <div class="wizard-wrapper">
            <div class="wizard-number">{{ getComboStepNumber }}</div>
            <div class="wizard-label">
              <div class="wizard-title">Sản phẩm combo</div>
              <div class="wizard-desc">Thiết lập sản phẩm combo</div>
            </div>
          </div>
        </div>

        <!-- Step 3/4 (Images) -->
        <div
          v-if="showImageStep"
          class="wizard-step"
          data-wizard-type="step"
          @click="handleStepClick(getImageStepNumber)"
        >
          <div class="wizard-wrapper">
            <div class="wizard-number">{{ getImageStepNumber }}</div>
            <div class="wizard-label">
              <div class="wizard-title">Hình ảnh sản phẩm</div>
              <div class="wizard-desc">Quản lý hình ảnh sản phẩm</div>
            </div>
          </div>
        </div>

        <!-- Step 4/5 (Inventory) -->
        <div
          v-if="showInventoryStep"
          class="wizard-step"
          data-wizard-type="step"
          @click="handleStepClick(getInventoryStepNumber)"
        >
          <div class="wizard-wrapper">
            <div class="wizard-number">{{ getInventoryStepNumber }}</div>
            <div class="wizard-label">
              <div class="wizard-title">Tồn kho</div>
              <div class="wizard-desc">Chi tiết tồn kho sản phẩm</div>
            </div>
          </div>
        </div>

        <!-- Step 5/6 (History) -->
        <div
          v-if="showHistoryStep"
          class="wizard-step"
          data-wizard-type="step"
          @click="handleStepClick(getHistoryStepNumber)"
        >
          <div class="wizard-wrapper">
            <div class="wizard-number">{{ getHistoryStepNumber }}</div>
            <div class="wizard-label">
              <div class="wizard-title">Lịch sử</div>
              <div class="wizard-desc">Lịch sử thay đổi sản phẩm</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wizard-body py-3">
      <div class="tab-content">
        <!-- Step 1 Content -->
        <div class="tab-pane" :class="{ 'active show': currentStep === 1 }">
          <slot name="step-1"></slot>
        </div>

        <!-- Step 2 Content (Pricing) -->
        <div
          v-if="showPricingStep"
          class="tab-pane"
          :class="{ 'active show': currentStep === 2 }"
        >
          <slot name="step-pricing"></slot>
        </div>

        <!-- Step 3 Content (Combo) -->
        <div
          v-if="showCombo"
          class="tab-pane"
          :class="{ 'active show': currentStep === getComboStepNumber }"
        >
          <slot name="step-2"></slot>
        </div>

        <!-- Step 4 Content (Images) -->
        <div
          v-if="showImageStep"
          class="tab-pane"
          :class="{ 'active show': currentStep === getImageStepNumber }"
        >
          <slot name="step-3"></slot>
        </div>

        <!-- Step 5 Content (Inventory) -->
        <div
          v-if="showInventoryStep"
          class="tab-pane"
          :class="{ 'active show': currentStep === getInventoryStepNumber }"
        >
          <slot name="step-4"></slot>
        </div>

        <!-- Step 6 Content (History) -->
        <div
          v-if="showHistoryStep"
          class="tab-pane"
          :class="{ 'active show': currentStep === getHistoryStepNumber }"
        >
          <slot name="step-5"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductWizard',
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
    showCombo: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: 'edit',
    },
  },
  computed: {
    showPricingStep() {
      return this.action !== 'add';
    },
    showImageStep() {
      return this.action !== 'add';
    },
    showInventoryStep() {
      return this.action !== 'add';
    },
    showHistoryStep() {
      return this.action !== 'add';
    },
    getComboStepNumber() {
      return 3;
    },
    getImageStepNumber() {
      return this.showCombo ? 4 : 3;
    },
    getInventoryStepNumber() {
      return this.showCombo ? 5 : 4;
    },
    getHistoryStepNumber() {
      return this.showCombo ? 6 : 5;
    },
  },
  methods: {
    handleStepClick(step) {
      this.$emit('step-changed', step);
    },
  },
};
</script>
